import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { AuthService } from '../../../shared/services/auth.service';
import { FileItem } from '../../models/files';
import { TargetColumnsConfig } from '../../../../API';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-file-upload-step',
  templateUrl: './file-upload-step.component.html',
  styleUrls: ['./file-upload-step.component.scss'],
})
export class FileUploadStepComponent implements OnInit {
  @Input() files: FileItem[] = [];
  @Input() fields: TargetColumnsConfig[] = [];
  @Input() getBeforeUploadHandler!: (index: number) => any;

  @Output() addFile = new EventEmitter<void>();
  @Output() removeFile = new EventEmitter<number>();
  @Output() clearFiles = new EventEmitter<void>();

  @Output() isFormValid = new EventEmitter<boolean>();

  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    this.fields = this.authService.getTargetColumns();

    this.fileItemFileForm.valueChanges.subscribe((_newValue) => {
      this.isFormValid.emit(this.fileItemFileForm.valid);
    });
  }

  get fileItemFileForm(): UntypedFormGroup {
    return this.files[0].fileForm as UntypedFormGroup;
  }
}
